import { isTextNode } from 'anodum';
import isBreakElement from '../verifiers/is-break-element';
import { NBSP_STRING } from '../constants/common';

const findLastTextNode = (element, includeBreakNodeToSearch = false) => {
  if (!element) return null;
  if (isTextNode(element) || (includeBreakNodeToSearch && isBreakElement(element))) return element;
  if (!element.hasChildNodes()) return null;

  let lastTextNode = null;
  let currentNode = element;
  while (currentNode) {
    if (currentNode.lastChild) {
      currentNode = currentNode.lastChild;
    } else if (currentNode.previousSibling) {
      currentNode = currentNode.previousSibling;
    } else {
      while (!currentNode.previousSibling) {
        if (currentNode === element) {
          return lastTextNode;
        }
        currentNode = currentNode.parentNode;
      }

      if (currentNode === element) {
        return lastTextNode;
      }
      currentNode = currentNode.previousSibling;
    }

    if (isTextNode(currentNode)) {
      const { nodeValue } = currentNode;
      if (nodeValue.trim().length || nodeValue.includes(NBSP_STRING)) {
        lastTextNode = currentNode;
        break;
      }
    }

    if (includeBreakNodeToSearch && isBreakElement(currentNode)) {
      lastTextNode = currentNode;
      break;
    }
  }
  return lastTextNode;
};

export default findLastTextNode;
